/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import React from 'react';
import { GatsbyBrowser } from 'gatsby';
import './src/styles/global.css';
import './src/styles/ws10-overrides.css';
import ABExperimentsRouter from './src/components/ABExperimentsRouter/ABExperimentsRouter';
import { updatePageView } from './src/helpers/kampyleOnsiteSDK';

export const onInitialClientRender: GatsbyBrowser['onInitialClientRender'] =
  () => {
    const hasHashInUrl = window.location.hash;

    if (!hasHashInUrl) {
      window.scrollTo(0, 0);
    }
  };

export const shouldUpdateScroll: GatsbyBrowser['shouldUpdateScroll'] = () => [
  0, 0,
];

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({
  element,
}) => {
  return (
    <ABExperimentsRouter cookieName="X-Experiment">
      {element}
    </ABExperimentsRouter>
  );
};

export const onRouteUpdate: GatsbyBrowser['onRouteUpdate'] = () => {
  updatePageView();
}

/*
exports.onRouteUpdate = ({ location, prevLocation }) => {
  var body = document.getElementById('scroll-root');
  // NB -Body will not exist if the current page is 
  // the development version of the 404 page.
  if (body) {
    body.scrollTo(0, 0);
  }
};
*/
